import { defineMessages } from 'react-intl';

export default defineMessages({
    searchContactTitle: {
        id: 'gateway.views.search-contacts.input.Search Address Book',
        defaultMessage: 'Search Address Book',
    },
    additionalContactType: {
        id: 'gateway.views.search-contacts.input.ContactType',
        defaultMessage: 'Type',
    },
    additionalPerson: {
        id: 'gateway.views.search-contacts.input.Person',
        defaultMessage: 'Person',
    },
    additionalCompany: {
        id: 'gateway.views.search-contacts.input.Company',
        defaultMessage: 'Company',
    },
    addNew: {
        id: 'gateway.views.search-contacts.input.Add New',
        defaultMessage: 'Add New',
    },
    cancelSearch: {
        id: 'gateway.views.search-contacts.input.Cancel',
        defaultMessage: 'Cancel',
    },
    searchAdditionalContact: {
        id: 'gateway.views.search-contacts.input.Search',
        defaultMessage: 'Search',
    },
    additionalContactFirstName: {
        id: 'gateway.views.search-contacts.input.FirstName',
        defaultMessage: 'First Name',
    },
    additionalContactLastName: {
        id: 'gateway.views.search-contacts.input.LastName',
        defaultMessage: 'Last Name',
    },    
    contactHeaderName: {
        id: 'gateway.views.search-contacts.input.Name',
        defaultMessage: 'Name'
    },
    contactHeaderAddress: {
        id: 'gateway.views.search-contacts.input.Address',
        defaultMessage: 'Address'
    },
    noContacts: {
        id: 'gateway.views.search-contacts.input.No results found!',
        defaultMessage: 'No Contacts'
    },
    addContact: {
        id: 'gateway.views.search-contacts.input.Add Contact',
        defaultMessage: 'Add'
    }
});
